const DateConvert = (isoString: string): string => {
	if (!isoString) return 'Fecha inválida'

	const date = new Date(isoString)

	if (isNaN(date.getTime())) return 'Fecha inválida'

	const parts = new Intl.DateTimeFormat('es-ES', {
		timeZone: 'America/Bogota',
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	}).formatToParts(date)

	const day = parts.find((p) => p.type === 'day')?.value ?? ''
	const month = parts.find((p) => p.type === 'month')?.value ?? ''
	const year = parts.find((p) => p.type === 'year')?.value ?? ''

	let time = new Intl.DateTimeFormat('es-ES', {
		timeZone: 'America/Bogota',
		hour: 'numeric',
		minute: '2-digit',
		hour12: true,
	}).format(date)

	time = time.replace(/a\.\s?m\./i, 'AM').replace(/p\.\s?m\./i, 'PM')

	return `${day} de ${month} - ${year} a las ${time}`
}

export default DateConvert
